let lastScrollTop = 0;
const body = document.body;

window.addEventListener("scroll", function () {
  const currentScroll =
    window.pageYOffset || document.documentElement.scrollTop;

  if (currentScroll < lastScrollTop) {
    // Scrolling up
    body.classList.add("scrolling-up");
    body.classList.remove("scrolling-down");
  } else {
    // Scrolling down
    body.classList.add("scrolling-down");
    body.classList.remove("scrolling-up");
  }

  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Avoid negative values
});




// ===== Sticky Selected Color Preview =====
var colorStickyState = {
  isVisible: false
};

function createColorSticky() {
  // Only on mobile
  if (window.innerWidth > 768) return null;
  
  var sticky = document.getElementById('cl-color-sticky-preview');
  if (!sticky) {
    sticky = document.createElement('div');
    sticky.id = 'cl-color-sticky-preview';
    sticky.style.position = 'fixed';
    sticky.style.top = '0';
    sticky.style.left = '0';
    sticky.style.right = '0';
    sticky.style.zIndex = '10000';
    sticky.style.backgroundColor = 'white';
    sticky.style.padding = '8px 15px';
    sticky.style.borderBottom = '2px solid #e5e7eb';
    sticky.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
    sticky.style.display = 'flex';
    sticky.style.alignItems = 'center';
    sticky.style.justifyContent = 'center';
    sticky.style.minHeight = '60px';
    document.body.appendChild(sticky);
  }
  return sticky;
}

function updateColorSticky(colorInput) {
  if (window.innerWidth > 768) return;
  
  var sticky = createColorSticky();
  if (!sticky) return;
  
  var img = colorInput.closest('label').querySelector('img');
  if (img && img.src) {
    sticky.innerHTML = '';
    var imgClone = document.createElement('img');
    imgClone.src = img.src;
    imgClone.style.width = '135px';
    imgClone.style.height = '135px';
    imgClone.style.objectFit = 'cover';
    imgClone.style.borderRadius = '4px';    
    sticky.appendChild(imgClone);
    colorStickyState.isVisible = true;
    
    // Show/hide based on scroll
    if (window.scrollY > 300) {
      sticky.style.display = 'flex';
    } else {
      sticky.style.display = 'none';
    }
  }
}

// Initialize on page load
function initializeColorSticky() {
  if (window.innerWidth > 768) return;
  
  setTimeout(function() {
    var colorInput = document.querySelector('[data-option="Color"] input[name="v_Color"]:checked');
    if (colorInput) {
      updateColorSticky(colorInput);
    }
  }, 500);
}

// Listen to the custom option:changed event
window.addEventListener('option:changed', function(e) {
  var option = e.detail;
  
  if (option.name === 'Color') {
    var colorInput = document.querySelector('[data-option="Color"] input[name="v_Color"]:checked');
    if (colorInput) {
      updateColorSticky(colorInput);
    }
  }
});



// Hide sticky when scrolled to top
window.addEventListener('scroll', function() {
  if (window.innerWidth > 768) return;
  
  var sticky = document.getElementById('cl-color-sticky-preview');
  if (!sticky || !colorStickyState.isVisible) return;
  
  if (window.scrollY < 300) {
    sticky.style.display = 'none';
  } else {
    sticky.style.display = 'flex';
  }
});

// Handle resize
window.addEventListener('resize', function() {
  if (window.innerWidth > 768) {
    var sticky = document.getElementById('cl-color-sticky-preview');
    if (sticky) sticky.style.display = 'none';
  } else {
    initializeColorSticky();
  }
});

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeColorSticky);
} else {
  initializeColorSticky();
}





// Sticky color image preview on mobile only
(function() {
  // Check if on mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }

  // Create sticky color bar
  function createStickyBar() {
    const existingBar = document.getElementById('cl-color-sticky-bar');
    if (existingBar) return;

    const stickyBar = document.createElement('div');
    stickyBar.id = 'cl-color-sticky-bar';
    stickyBar.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: white;
      border-bottom: 1px solid #e5e7eb;
         z-index: 100;
      display: none;
      justify-content: center;
      align-items: center;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    `;

    const imageContainer = document.createElement('div');
    imageContainer.id = 'cl-color-sticky-image';
    imageContainer.style.cssText = `
      width: 135px;
      height: 135px;
        overflow: hidden;
      flex-shrink: 0;
    `;

    stickyBar.appendChild(imageContainer);

    // Add to the top of page
    document.body.prepend(stickyBar);
  }

  // Update sticky bar when color changes
  function updateStickyBar() {
    const colorOption = document.querySelector('[data-option="Color"]');
    const stickyBar = document.getElementById('cl-color-sticky-bar');
    const imageContainer = document.getElementById('cl-color-sticky-image');

    if (!colorOption || !stickyBar || !imageContainer) return;

    const selectedInput = colorOption.querySelector('input[type="radio"]:checked');
    
    if (selectedInput) {
      const swatch = selectedInput.nextElementSibling;
      const img = swatch.querySelector('img');

      if (img) {
        // Clear previous content
        imageContainer.innerHTML = '';

        // Clone and append new image
        const newImg = img.cloneNode(true);
        newImg.style.cssText = `
          width: 100%;
          height: 100%;
          object-fit: contain;
        `;
        imageContainer.appendChild(newImg);
      }
    }
  }

  // Handle scroll and visibility
  function handleScroll() {
    if (!isMobile()) {
      const stickyBar = document.getElementById('cl-color-sticky-bar');
      if (stickyBar) stickyBar.style.display = 'none';
      return;
    }

    const colorOption = document.querySelector('[data-option="Color"]');
    const stickyBar = document.getElementById('cl-color-sticky-bar');

    if (!colorOption || !stickyBar) return;

    const colorRect = colorOption.getBoundingClientRect();
    const selectedInput = colorOption.querySelector('input[type="radio"]:checked');

    // Show sticky bar only when color option is not visible and a color is selected
    if (selectedInput && colorRect.top > window.innerHeight) {
      // Color option is below viewport
      stickyBar.style.display = 'flex';
    } else if (colorRect.bottom < 0) {
      // Color option is above viewport
      stickyBar.style.display = 'flex';
    } else {
      // Color option is visible on screen
      stickyBar.style.display = 'none';
    }
  }

  // Initialize on load
  function init() {
    if (!isMobile()) return;

    createStickyBar();
    updateStickyBar();

    // Listen for color changes
    window.addEventListener('option:changed', function(e) {
      if (e.detail && e.detail.name === 'Color') {
        updateStickyBar();
      }
    });

    // Listen for scroll
    window.addEventListener('scroll', handleScroll);

    // Handle window resize
    window.addEventListener('resize', function() {
      if (!isMobile()) {
        const stickyBar = document.getElementById('cl-color-sticky-bar');
        if (stickyBar) stickyBar.style.display = 'none';
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();